module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-left-panel-2-7a33e746a9ac7c01bc8f338dff61d689.svg";